import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  doc,
  getDoc as getFirestoreDoc,
  DocumentReference
} from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { IFirestoreService } from './firestore.interface';

@Injectable({ providedIn: 'root' })
export class FirestoreService implements IFirestoreService {
  private readonly firestore = inject(Firestore);
  private readonly cache = new Map<string, Observable<any>>();

  getDoc<T>(path: string, id: string): Observable<T> {
    const cacheKey = `${path}/${id}`;

    if (!this.cache.has(cacheKey)) {
      const ref = doc(this.firestore, path, id) as DocumentReference<T>;
      const request$ = from(getFirestoreDoc(ref)).pipe(
        map(snapshot => snapshot.data() as T),
        shareReplay({ bufferSize: 1, refCount: false })
      );
      this.cache.set(cacheKey, request$);
    }

    return this.cache.get(cacheKey)!;
  }
}